<template>
    <div class="row">

        <div
            v-if="loading"
            style="min-height: 80vh"
        >
            <div class="spinLoader">
                <i class="ti-reload"></i>
            </div>
        </div>

        <div v-if="!loading">
            <div class="text-right mb-3">
                <a :href="productDownloadUrl"><i class="ti-download"></i> Download full product stock report</a>
            </div>

            <div class="box">

                <div class="box-body">

                    <ul class="products container">
                        <li
                            class="row align-items-start"
                            v-for="(product, index) in data"
                            :key="index"
                        >
                            <div class="col-3">
                                <img
                                    style="width: 100%; height: auto; max-width: 175px"
                                    :src="product.img"
                                    fallback-src="http://placehold.it/500x500"
                                />
                            </div>

                            <div class="col-9 mb-5">
                                <div class="row">
                                    <h4 class="product-title">{{product.name}}</h4>

                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>SKU</th>
                                                <th>STOCK</th>
                                                <th>PRICE</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr
                                                v-for="model in product.stock"
                                                :key="model.sku"
                                            >
                                                <td>
                                                    <pre>{{model.sku}}</pre>
                                                </td>
                                                <td>
                                                    <pre>{{model.stock}}</pre>
                                                </td>
                                                <td>
                                                    <pre>{{model.price}}</pre>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                                <!--<div ng-show="product.stock == undefined">
                                            <strong>Stock is not being tracked on this product</strong>
                                        </div>-->
                            </div>

                        </li>
                    </ul>

                </div><!-- /.box-body -->
            </div><!-- /.box -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            data: {},
        };
    },

    computed: {
        productDownloadUrl: function () {
            return this.$config.apiUrl + "/products/" + this.$config.sites[this.$config.moniker].store_id + "/" + this.$config.moniker + "?export=true";
        } 
    },

    methods: {
        async fetchData() {
            const response = await fetch(
                this.$config.apiUrl + "/products/" + this.$config.sites[this.$config.moniker].store_id + '/' + this.$config.moniker
            );
            this.data = await response.json();
            this.loading = false;
        },
    },

    mounted: function () {
        this.fetchData();
    },
};
</script>


<style>
.products pre {
    margin-bottom: 0;
}
.products .table > tbody > tr > td {
    padding: 8px;
}
</style>
